import { axiosRequest } from '../../configs/axios.config';

export const getAssessmentsBy = (params) => {
  const defaultParams = { lang: 'es', page: 1, items: 10 };
  const queryParams = new URLSearchParams({
    ...defaultParams,
    ...params,
  }).toString();

  return axiosRequest
    .get(`/assessments?${queryParams}`)
    .then(({ data }) => data);
};
